import { gql, QueryResult, useQuery } from "@apollo/client";

import { Collection } from "../../../generated/gql/graphql";

const GET_COLLECTION = gql`
  query GetCollection($collectionId: String!) {
    collection(id: $collectionId) {
      id
      status
      sort
      name
      image
      userId
      sharedUserIds
      dateCreated
      dateUpdated
      createdBy
      externalServiceConnections
    }
  }
`;

export default function useCollection(
  id: string
): QueryResult<{ collection: Collection }> {
  return useQuery(GET_COLLECTION, {
    variables: {
      collectionId: id,
    },
  });
}
